"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIVACY_NOTICE_PLACEHOLDER_LABEL = void 0;
exports.PublicProfilePrivacyNotice = PublicProfilePrivacyNotice;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const PrivacyNoticeSections_1 = __importDefault(require("../../../Privacy/PrivacyNoticeSections"));
exports.PRIVACY_NOTICE_PLACEHOLDER_LABEL = "Tekst zastępczy - do zastąpienia przez administratora danych";
/**
 * ROD-7: informacja o przetwarzaniu danych osobowych na publicznym formularzu. Treść przychodzi
 * z backendu razem z informacją o zgłoszeniu (jedno źródło dla strony i maila z linkiem) - tu tylko
 * wyświetlanie. Plakietka „tekst zastępczy" ma być nie do przeoczenia, dopóki owner nie wstawi treści.
 */
function PublicProfilePrivacyNotice({ notice, compact = false }) {
    const [expanded, setExpanded] = (0, react_1.useState)(!compact);
    if (!notice)
        return null;
    return (react_1.default.createElement("section", { className: "mb-3", "aria-label": notice.title, "data-testid": "privacy-notice" },
        compact && (react_1.default.createElement("div", { className: "small text-muted mb-2" },
            "Informacja o przetwarzaniu danych osobowych jest dost\u0119pna do ponownego wgl\u0105du.",
            " ",
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", size: "sm", className: "p-0 align-baseline", onClick: () => setExpanded((value) => !value) }, expanded ? "Ukryj informację" : "Pokaż informację"))),
        expanded && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "light", className: "border mb-0" },
            react_1.default.createElement("div", { className: "d-flex align-items-center flex-wrap gap-2 mb-2" },
                react_1.default.createElement("h6", { className: "mb-0" }, notice.title),
                notice.isPlaceholder && react_1.default.createElement(react_bootstrap_1.Badge, { bg: "danger" }, exports.PRIVACY_NOTICE_PLACEHOLDER_LABEL)),
            react_1.default.createElement(PrivacyNoticeSections_1.default, { sections: notice.sections })))));
}
